/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';

export interface DeleteSetting_1$Params {
  settingId: number;
}

export function deleteSetting_1(http: HttpClient, rootUrl: string, params: DeleteSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, deleteSetting_1.PATH, 'delete');
  if (params) {
    rb.path('settingId', params.settingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupNotificationSetting>;
    })
  );
}

deleteSetting_1.PATH = '/api/facilityGroup/notification/setting/{settingId}';
